import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items:center;
`;

export const ControlButtonWrapper = styled.button`
  background-color: transparent;
  border: 0;
  margin-right: 8px;
`;

export const BottomContainer = styled.div`
  position: absolute;
  bottom: 16px;
  left: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
`;

export const VideoContainer = styled.div`
  border-radius: 8px;
  background-color: black;
  display: flex;
  overflow: hidden;
`;

export const ButtonsContainer = styled.div`
  gap: 8px;
`;

export const ProgressContainer = styled.div`
  // width: 380px;
  align-self: center;
  cursor: pointer;
`;

export const LocalProgressContainer = styled.div`
  width: 300px;
  align-self: center;
  cursor: pointer;
`;

export const LocalBottomContainer = styled.div`
  position: absolute;
  bottom: 50px;
  left: 50px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
`;